export const API_BASE_URL = window?.__RUNTIME_CONFIG__?.VITE_BASE_URL ?? "";
export const API_AUTH_URL = window?.__RUNTIME_CONFIG__?.VITE_AUTH_URL ?? "";
export const IDENTITY_CLIENT_ID = window?.__RUNTIME_CONFIG__?.VITE_IDENTITY_CLIENT_ID ?? "";
export const REDIRECT_URL = window?.__RUNTIME_CONFIG__?.VITE_REDIRECT_URL ?? "";
export const SILENT_REDIRECT_URL = window?.__RUNTIME_CONFIG__?.VITE_SILENT_REDIRECT_URL ?? "";
export const LOG_OFF_REDIRECT_URL = window?.__RUNTIME_CONFIG__?.VITE_LOGOFF_REDIRECT_URL ?? "";
export const TIMER = window?.__RUNTIME_CONFIG__?.VITE_SET_TIMER ?? "";
